import { FormField } from "@/components/FormBits";
import { brl } from "@/lib/api";

export const parseMoney = (v) => Number(String(v).replace(",", ".")) || 0;

export function CashPayment({ total, value, onChange }) {
  const diff = Math.round((parseMoney(value) - total) * 100) / 100;
  return (
    <div className="space-y-3 rounded-md border-2 border-emerald-500 bg-emerald-50 p-4" data-testid="cash-panel">
      <FormField id="cash-received" label="Valor recebido (R$)" type="number" step="0.01" min="0" required value={value} onChange={(e) => onChange(e.target.value)} />
      <div className="flex justify-between text-sm text-slate-600"><span>Total do pedido</span><span className="font-mono">{brl(total)}</span></div>
      {diff >= 0 ? (
        <div className="flex justify-between text-sm font-bold text-emerald-800" data-testid="cash-change"><span>Troco</span><span className="font-mono">{brl(diff)}</span></div>
      ) : (
        <div className="flex justify-between text-sm font-bold text-amber-800" data-testid="cash-remaining"><span>Restante a pagar</span><span className="font-mono">{brl(-diff)}</span></div>
      )}
      <p className="text-xs text-slate-500">{diff >= 0 ? "O pedido entra como pago." : "O restante a pagar fica informado na Nota de Serviço."}</p>
    </div>
  );
}

export function CashInfo({ order }) {
  if (order.payment_method !== "cash") return null;
  const due = order.payment_status === "paid" ? 0 : order.amount_due || 0;
  const cells = [["Recebido", order.cash_received || 0, "cash-info-received"], ["Troco", order.cash_change || 0, "cash-info-change"], ["Restante a pagar", due, "cash-info-due"]];
  return (
    <div className="grid grid-cols-3 gap-2 rounded-md border border-emerald-200 bg-emerald-50 p-3 text-xs" data-testid="cash-info">
      {cells.map(([label, v, id]) => (
        <div key={id}>
          <p className="text-slate-500">{label}</p>
          <p className={`font-mono text-sm font-bold ${id === "cash-info-due" && v > 0 ? "text-amber-700" : "text-slate-900"}`} data-testid={id}>{brl(v)}</p>
        </div>
      ))}
    </div>
  );
}
